module.exports = __webpack_public_path__ + "static/media/filterIcon.930e1454.svg";